import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Divider, Tab } from '@mui/material'
import { Error } from 'components/Error'
import { Loading } from 'components/Loading'
import { TablePagination } from 'components/TablePagination'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryState } from 'react-router-use-location-state'
import { useTendersClientOverviewQuery } from 'services/tender'
import { DashboardContestCard } from './dashboard-contest-card'

const enum ETenderListType {
  ONGOING = 'ongoing-contests',
  PARTICIPATE = 'participate-contests',
}

const TenderListType = {
  ongoing: ETenderListType.ONGOING,
  participate: ETenderListType.PARTICIPATE,
}

export const DashboardContestList = () => {
  const [tab, setTab] = useState<ETenderListType>(TenderListType.ongoing)
  const { t } = useTranslation()
  const [page, setPage] = useQueryState('page', 0)

  const rowsPerPage = 10

  const args = {
    participating: tab === TenderListType.participate,
    page,
    size: rowsPerPage,
  } as const

  const { data, isError, isLoading } = useTendersClientOverviewQuery(args, {
    refetchOnMountOrArgChange: true,
  })

  const tenderListTypeTabs = useMemo(
    () => [
      {
        value: TenderListType.ongoing,
        label: t(`${TenderListType.ongoing}`),
      },
      {
        value: TenderListType.participate,
        label: t(`${TenderListType.participate}`),
      },
    ],
    [t]
  )

  if (isLoading) return <Loading fullPage={false} />

  if (isError) return <Error />

  if (data === undefined) {
    return <></>
  }

  return (
    <Box sx={{ marginTop: '50px' }}>
      <TabContext value={tab}>
        <TabList
          onChange={(_event, newValue) => {
            setTab(newValue)
            setPage(0)
          }}
          sx={{
            '&& .MuiTabs-flexContainer': {
              justifyContent: 'center',
            },
          }}
        >
          {tenderListTypeTabs.map(({ value, label }) => (
            <Tab key={value} label={label} value={value} />
          ))}
        </TabList>
        <Divider flexItem sx={{ marginTop: '30px' }} />

        <TabPanel value={TenderListType.ongoing}>
          {data.items.map((item) => {
            return (
              <DashboardContestCard key={item.tenderId} dashboardContest={item} participating={false} />
            )
          })}
        </TabPanel>
        <TabPanel value={TenderListType.participate}>
          {data.items.map((item) => {
            return (
              <DashboardContestCard key={item.tenderId} dashboardContest={item} participating={true} />
            )
          })}
        </TabPanel>
      </TabContext>
      {data.info.totalRows !== 0 && (
        <TablePagination
          total={data.info.totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={setPage}
        />
      )}
    </Box>
  )
}
